module.exports = __webpack_public_path__ + "img/022d8a4.webp";